import React from 'react'
import {useState, useEffect} from "react";

import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import '../../scss/tabs.scss'

import {useLocation} from 'react-router-dom';
import instance from "../../api/axios";
import {Cookies} from "react-cookie";


const Result = () => {

    const navigate = useNavigate()

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const edpBillNo = queryParams.get('order');
    let url = process.env.REACT_APP_BASE_URL;

    const [order, setOrder] = useState('')
    const [email, setEmail] = useState('')
    const [payed, setPayed] = useState()
    const {t, i18n} = useTranslation()
    const [loading, setLoading] = useState(true);

    const cookies = new Cookies();
    const getOrderInfo = async () => {
        await instance.get(`${url}/abio/public/cart/resetOrder`, {
            headers: {
                'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
            },
            params: {
                orderId: edpBillNo
            }
        }).then(response => {
            setOrder(response.data.id)
            setEmail(response.data.email)
            setPayed(response.data.payed)
        }).then(response => setOrder(response.data.id))
            .catch(error => console.log(error))
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getOrderInfo()
    }, []);

    return (
        <div className='succes'>

            <style>
                {`
.loadingBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top-color: #5a8dee;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`}
            </style>

            {loading ? (
                <div className="loadingBox">
                    <div className="spinner"></div>
                    <p>{t("Tabs.waiting")}</p>
                </div>
            ) : (payed ? (
                    <>
                        <div className='modalCont'>
                            <h2>{t("Tabs.thanks")}</h2>

                        </div>
                        <div className="modalText">{t("Tabs.thanksdetail1")} <span> {order} </span>
                            {t("Tabs.thanksdetail2")} {email} {t("Tabs.thanksdetail3")} </div>
                        <Link to={`/${i18n.language}`}>
                            <button className="continuShop">{t("shop.continue")}</button>
                        </Link>
                    </>
                ) : (<>
                        <div className='amerfail'>
                            <div className='modalCont'>
                                <h2 className='errortext'>{t("Tabs.thankserror")}</h2>

                            </div>

                            <Link to={`/${i18n.language}`}>
                                <button className="continuShop">{t("shop.continue")}</button>
                            </Link>
                        </div>
                    </>

                )
            )}


        </div>
    )
}

export {Result}
